import React from 'react';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';

const CsatDialog = ({ open, handleConfirm, handleCloseApi }) => {
  return (
    <Dialog 
    open={open} 
    onClose={(event, reason) => {
      if (reason !== 'backdropClick') {
        handleCloseApi();
      }
    }} 
    maxWidth="sm" 
    fullWidth
  >
  

      {/* ส่วนหัว Dialog พร้อมปุ่มปิด */}
      <DialogTitle
        sx={{
          fontSize: '1.5rem',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <StarIcon sx={{ fontSize: 30, color: 'gold' }} /> แบบประเมินความพึงพอใจ{' '}
        <StarIcon sx={{ fontSize: 30, color: 'gold' }} />
      </DialogTitle>

      {/* เนื้อหา Dialog */}
      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        {/* ไอคอนดาว */}
        <Typography variant="h6" sx={{ fontSize: '1.3rem', mt: 1 }}>
          "แบ่งปันความคิดเห็นของคุณ เพื่อพัฒนาระบบให้ดียิ่งขึ้น"
        </Typography>
      </DialogContent>

      {/* ปุ่มกดยืนยัน และปิด */}
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          sx={{ fontSize: '1rem', color: 'white', minWidth: '100px' }}
        >
          ทำแบบประเมิน
        </Button>
        <Button
          onClick={handleCloseApi}
          variant="contained"
          color="error"
          sx={{ fontSize: '1rem', color: 'white', minWidth: '100px' }}
        >
          ยกเลิก
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CsatDialog;
